export const filter = {
  period: 'Jangka',
  period_buy: 'Periode pembelian',
  search: 'Cari',
  show_result: 'Tunjukan',
  name: 'Nama',
  mcc: 'MCC',
  mnc: 'MNC'
};
